import { MessageCircle, FileText, Monitor, Code2, RefreshCw, Rocket } from "lucide-react";
import { MASCOT } from "./brand";

const steps = [
    { n: "01", Icon: MessageCircle, title: "相談", body: "課題やご要望を ヒアリングします" },
    { n: "02", Icon: FileText, title: "業務整理", body: "業務の流れを整理し、 課題を明確にします" },
    { n: "03", Icon: Monitor, title: "画面設計", body: "使いやすい画面を 一緒に設計します" },
    { n: "04", Icon: Code2, title: "試作", body: "試作品で動作や 使い勝手を確認します" },
    { n: "05", Icon: RefreshCw, title: "改善", body: "フィードバックをもとに 改善を重ねます" },
    { n: "06", Icon: Rocket, title: "運用開始", body: "本番環境で運用開始。 サポートもお任せください" },
];

export default function Process() {
    return (
        <section
            id="process"
            data-testid="process-section"
            className="relative py-24 sm:py-32 bg-[#FAFCF5]"
        >
            <div className="max-w-7xl mx-auto px-5 sm:px-8">
                <div className="text-center max-w-3xl mx-auto mb-14">
                    <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white border border-[#C8E0AC] text-xs font-bold tracking-widest uppercase text-[#4A7A2F]">
                        FLOW — 開発の流れ
                    </div>
                    <h2
                        data-testid="process-title"
                        className="mt-5 text-4xl sm:text-5xl lg:text-6xl font-bold text-[#1F2A23] leading-tight"
                    >
                        いきなり作らず、
                        <br />
                        <span className="text-[#7DB856]">業務を整理</span>するところから。
                    </h2>
                </div>

                <div className="relative">
                    <ol className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 sm:gap-4">
                        {steps.map((s, idx) => (
                            <li
                                key={s.n}
                                data-testid={`process-step-${idx}`}
                                className="relative rounded-2xl bg-white border border-[#E6EFD8] p-5 hover:shadow-soft transition-all duration-300"
                            >
                                <div className="flex items-center justify-between mb-3">
                                    <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-[#7DB856] text-white text-xs font-bold">
                                        {s.n}
                                    </span>
                                    <s.Icon size={20} strokeWidth={2.5} className="text-[#7DB856]" />
                                </div>
                                <h3 className="text-base font-extrabold text-[#1F2A23] leading-tight">
                                    {s.title}
                                </h3>
                                <p className="mt-2 text-[11px] sm:text-xs text-[#5C6B5E] leading-relaxed">
                                    {s.body}
                                </p>

                                {idx < steps.length - 1 && (
                                    <span
                                        aria-hidden
                                        className="hidden lg:block absolute top-1/2 -translate-y-1/2 -right-3 text-[#7DB856] text-xl font-bold"
                                    >
                                        →
                                    </span>
                                )}
                            </li>
                        ))}
                    </ol>

                    {/* Mascot at the right end - celebrating */}
                    <img
                        src={MASCOT.jumping}
                        alt=""
                        data-testid="process-mascot"
                        aria-hidden
                        className="hidden lg:block absolute -right-4 -top-32 w-36 h-36 object-contain animate-float drop-shadow-[0_12px_24px_rgba(122,167,87,0.18)]"
                        draggable={false}
                    />
                </div>
            </div>
        </section>
    );
}
